export default __webpack_public_path__ + "static/media/shopping-cart.5d079001.svg";